import { UserState } from './reducer';

export type UserActions =
    | {
          type: 'ADD_USER_DATA';
          payload: any;
          schema: keyof UserState;
      }
    | {
          type: 'CLEAR_USER_DATA';
      }
    | {
          type: 'REMOVE_UNHANDLED_COLLECTOR_DOCUMENT';
          payload: any;
      };

export const addUserData = (
    schema: keyof UserState,
    payload: any,
): UserActions => ({
    payload,
    schema,
    type: 'ADD_USER_DATA',
});

export const addShortcodes =
    (shortcodeData: Record<string, unknown>) => async (dispatch: any) => {
        dispatch(addUserData('shortcodes', shortcodeData));
    };

export const removeUnhandledCollectorDocument =
    (data: any) => (dispatch: any) =>
        dispatch({
            type: 'REMOVE_UNHANDLED_COLLECTOR_DOCUMENT',
            payload: data,
        });

export const clearUserData = (): UserActions => ({
    type: 'CLEAR_USER_DATA',
});
